import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Config } from '../config/env.config';
import { BaseHttpService } from '../base/_base-http.service';
import { contentHeaders } from 'common/headers';
import * as _ from 'lodash';
import {catchError} from 'rxjs/operators';


@Injectable()
export class VehicleService extends BaseHttpService {

  filtersUrl: string = 'apps/ymm-filter';

  fetch(brandId: any, status: string, make: any = '', model: any = '', year: any = '', itemId: any = ''): Observable<any> {
    return this.http.get(
      `${Config.API}/${this.filtersUrl}/${brandId}/${status}?make=${make}&model=${model}&year=${year}&itemId=${itemId}`)

        .pipe(catchError(this.handleError.bind(this)));
  }
}
